//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Form from 'vform'
import { mapGetters, mapState } from 'vuex'
import GTM from '~/utils/classes/Gtm'
import veeValidate from '~/mixins/veeValidate'
import VueToastMixin from '~/mixins/plugins/vue-toastification'

export default {
  name: 'RegisterForm',
  mixins: [veeValidate, VueToastMixin],
  data () {
    return {
      formIsBusy: false,
      formIsNotFull: false,
      errorForm: new Form({
        error: ''
      }),
      form: new Form({
        first_name: '',
        last_name: '',
        email: '',
        password: ''
      }),
      formRules: {
        first_name: '',
        last_name: '',
        email: 'email',
        password: 'password'
      },
      gtm: new GTM(this.$gtm)
    }
  },
  computed: {
    ...mapState({
      googleClientId: 'googleClientId',
      facebookAppId: 'facebookAppId'
    }),
    ...mapGetters({
      locale: 'lang/locale'
    })
  },
  mounted () {
    this.$store.dispatch('auth/setAuthScript')
    const timer = setInterval(() => {
      if (!window.google.accounts) {
        return
      }
      clearInterval(timer)

      window.google.accounts.id.initialize({
        client_id: this.googleClientId,
        callback: this.processGoogleAuth,
        auto_select: true
      })
      window.google.accounts.id.renderButton(
        this.$refs.googleLoginBtn, {
          size: 'large', // or 'small' | 'medium'
          width: '200', // max width 400
          shape: 'pill',
          theme: 'filled_blue', // or 'filled_black' |  'filled_blue'
          logo_alignment: 'left' // or 'center'
        }
      )
    }, 200)
  },
  methods: {
    goToAnotherMethod () {
      if (['login', 'register'].includes(this.$route.name)) {
        this.$router.push({ name: 'login' })
        return
      }
      this.$modal.hide('register-modal')
      this.$modal.show('login-modal')
    },
    statusChangeCallback (response) {
      if (response.status === 'connected') {
        this.processFacebookAuth(response)
      }
    },
    checkLoginState () {
      window.FB.init({
        appId: this.facebookAppId,
        cookie: true,
        xfbml: true,
        version: 'v2.10'
      })

      window.FB.login((response) => {
        this.statusChangeCallback(response)
      }, { scope: 'email' })
    },
    async processFacebookAuth (response) {
      return await this.$store.dispatch('auth/loginFromFacebook', {
        ...response.authResponse,
        access_token: response.authResponse.accessToken,
        locale: this.locale,
        provider: 'facebook'
      }).then(async (resp) => {
        if (resp?.data?.user?.new_user) {
          await this.$store.dispatch('auth/updateUser', resp.data.user)
          await this.gtm.signUpEvent('Facebook')
          await this.$store.dispatch('auth/callActionsAfterRegister', { ctx: this, user: resp.data.user, type: 'social', campaign: true })
        } else if (resp?.user?.new_user) {
          await this.$store.dispatch('auth/updateUser', resp.user)
          await this.gtm.signUpEvent('Facebook')
          await this.$store.dispatch('auth/callActionsAfterRegister', { ctx: this, user: resp.user, type: 'social', campaign: true })
        } else {
          this.gtm.loginEvent('Facebook')
        }

        this.redirectAfterSuccess()
        this.$emit('close')
      }).catch((e) => {
        console.log(e)
      })
    },
    async processGoogleAuth (response) {
      window.localStorage.setItem('google_access_token', response.credential)

      return await this.$store.dispatch('auth/loginFromGoogle', {
        ...response,
        locale: this.locale,
        provider: 'google'
      }).then(async (resp) => {
        if (resp?.data?.user?.new_user) {
          await this.$store.dispatch('auth/updateUser', resp.data.user)
          await this.gtm.signUpEvent('Google')
          await this.$store.dispatch('auth/callActionsAfterRegister', { ctx: this, user: resp.data.user, type: 'social', campaign: true })
        } else if (resp?.user?.new_user) {
          await this.$store.dispatch('auth/updateUser', resp.user)
          await this.gtm.signUpEvent('Google')
          await this.$store.dispatch('auth/callActionsAfterRegister', { ctx: this, user: resp.user, type: 'social', campaign: true })
        } else {
          this.gtm.loginEvent('Google')
        }

        this.redirectAfterSuccess()
        this.$emit('close')
      }).catch((e) => {
        console.log(e)
      })
    },
    async check () {
      const isValid = await this.$refs.formObs.validate()
      if (!isValid) {
        return true
      }
      let isError = false
      this.formIsNotFull = false
      this.form.keys().forEach((key) => {
        if (this.form[key] === '' &&
          key !== '') {
          this.formIsNotFull = true
          this.form.errors.set(key, '')
          isError = true
        }
      })
      return isError
    },
    async submit () {
      this.errorForm.errors.clear()
      this.formIsNotFull = false
      this.formIsBusy = true

      if (await this.check()) {
        this.formIsBusy = false
        return
      }

      const token = await window.grecaptcha.enterprise.execute('6LergzosAAAAANRiH17D_j0qby18iQk2R5L2gjW7', {action: 'REGISTER'}) //this.$recaptcha.getResponse()
      let response
      try {
        const data = this.form.data()
        data.current_language = this.locale
        data.gRecaptchaResponse = token
        data.role_id = 4
        data.referral_id = this.$store.getters['auth/referralCode']
        response = await this.$aProxy.post('/proxy?proxyUrl=/register', data)
      } catch (e) {
        this.form.errors.set(e.response?.data?.errors)
        const error = e.response?.data?.error
        switch (error) {
          case 'not_human':
            this.$toast.error(this.$t('we-could-not-verify-you-r'))
            break
          case 'email_exists':
            this.form.errors.set({
              email: this.$t('this-email-address-alread')
            })
            break
          case 'not_allowed':
            this.form.errors.set({
              password: this.$t('this-email-address-is-not')
            })
            break
          default:
            this.$toast.error(this.$t('an-error-has-occurred'))
            break
        }

        this.formIsBusy = false
      }

      if (response?.data?.data) {
        await this.$store.dispatch('auth/saveToken', {
          token: response.data.data.token,
          remember: true
        })
        this.gtm.signUpEvent('e-mail')
        await this.$store.dispatch('auth/updateUser', response.data.data)

        await this.$store.dispatch('auth/callActionsAfterRegister', { ctx: this, campaign: true})
        await this.redirectAfterSuccess()
        this.$emit('close')
      }
    },
    async redirectAfterSuccess () {
      if (this.$route.name === 'register') {
        this.$router.push({ name: 'manager.dashboard' }).catch((e) => {})
      }
    }
  }
}
